import React from 'react'

import { colors } from '@flowwai-frontend/shared/style-guide'

import { IconPropsType } from '../types'

const Trash03Icon = (props: IconPropsType): React.ReactElement => {
   const { stroke = colors['error-600'], ...rest } = props

   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width={18}
         height={18}
         fill='none'
         viewBox='0 0 18 18'
         {...props}
      >
         <path
            stroke={stroke}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.5}
            d='M6.75 2.25h4.5m-9 2.25h13.5m-1.5 0-.526 7.89c-.079 1.183-.118 1.775-.374 2.224a2.25 2.25 0 0 1-.974.91c-.464.226-1.058.226-2.244.226H7.868c-1.186 0-1.78 0-2.244-.225a2.25 2.25 0 0 1-.974-.911c-.256-.449-.295-1.04-.374-2.225L3.75 4.5M7.5 7.875v3.75m3-3.75v3.75'
         />
      </svg>
   )
}

export { Trash03Icon }
